// src/TEST/gateways/Stripe/StripeCheckout.js
import React from "react";
import StripePaymentMethodWrapper from "./StripePaymentMethodWrapper";
import StripePaymentElements from "./StripePaymentElements";

const StripeCheckout = ({
  selectedGateway,
  stripeOptions,

  store_slug,
  price_slug,

  fullName,
  email,
  selectedCountry,
  selectedState,
  stateOptions,
  postalCode,
  dialingCode,
  contactNumber,
  agreementAccepted,
  couponCode,

  freeTrialNoCard,
}) => {
  return (
    <StripePaymentMethodWrapper
      key={selectedGateway._id}
      public_key={selectedGateway.stripe_publishable_key}
      options={stripeOptions}
    >
      <StripePaymentElements
        store_slug={store_slug}
        price_slug={price_slug}
        gateway_id={selectedGateway._id}
        fullName={fullName}
        email={email}
        selectedCountry={selectedCountry}
        selectedState={selectedState}
        stateOptions={stateOptions}
        postalCode={postalCode}
        dialingCode={dialingCode}
        contactNumber={contactNumber}
        agreementAccepted={agreementAccepted}
        couponCode={couponCode}
        freeTrialNoCard={freeTrialNoCard}
      />
    </StripePaymentMethodWrapper>
  );
};

export default StripeCheckout;
